import { ChevronRight } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

const FIELDS = [
  ["quotation_number", "Quotation number", true, "Unique number set by admin"],
  ["version_label", "Version / revision", true, "Set automatically — R0, then R1 when an issued quotation is edited", "text", false, true],
  ["quotation_date", "Quotation date", true, "", "date"],
  ["client_name", "Client / customer name", true],
  ["project_name", "Project name", true],
  ["prepared_by", "Proposal prepared by", true],
  ["location", "Project location / address", true, "", "text", true],
  ["contact_name", "Contact person", false],
  ["contact_phone", "Contact phone", false],
  ["contact_email", "Contact email", false],
  ["interior_area_sqft", "Total interior area (sq.ft)", false, "Optional — used for interior rate per sq.ft"],
];

export function DetailsPanel({ q, calc, readOnly, actions, onNext }) {
  const missing = new Set(calc.errors.filter((e) => e.section_key === "details").map((e) => e.field));
  return (
    <div className="space-y-8" data-testid="qg-details-panel">
      <header>
        <p className="font-mono text-xs text-brillien-600 font-semibold">STEP 1</p>
        <h2 className="font-heading text-2xl font-bold tracking-tight text-slate-900 dark:text-white">Project details</h2>
        <p className="text-sm text-slate-500 mt-1">Fields marked * are required before the final quotation can be generated.</p>
      </header>
      <div className="grid md:grid-cols-2 gap-5 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 p-6">
        {FIELDS.map(([f, label, req, hint, type, wide, locked]) => (
          <label key={f} className={`block space-y-1.5 ${wide ? "md:col-span-2" : ""}`}>
            <span className="text-xs font-semibold text-slate-700 dark:text-slate-200">{label}{req && <span className="text-brillien-600"> *</span>}</span>
            <Input type={type || "text"} value={q[f] || ""} disabled={readOnly || locked} onChange={(e) => actions.setField(f, e.target.value)}
              inputMode={f === "interior_area_sqft" ? "decimal" : undefined}
              className={`rounded-lg ${missing.has(f) ? "border-red-400 ring-1 ring-red-200" : ""}`} data-testid={`qg-detail-${f}`} />
            {missing.has(f) ? <span className="text-[11px] text-red-600">Required</span> : hint ? <span className="text-[11px] text-slate-400">{hint}</span> : null}
          </label>
        ))}
      </div>
      <div className="flex justify-end">
        <Button variant="ghost" onClick={onNext} data-testid="qg-next-btn" className="rounded-lg">Next: Civil works<ChevronRight className="h-4 w-4 ml-1" /></Button>
      </div>
    </div>
  );
}
